<template>
	<div id="bzt-app">
		<div id="bzt-main"></div>
	</div>
</template>
<script>
	let myChart
	export default {
		name: "bzt-app",
		props:['data1','name','data2'],
		methods: {
			drawChart() {
				let _this=this
				// 基于准备好的dom，初始化echarts实例
				 myChart = this.$echarts.init(document.getElementById("bzt-main"));
				// 指定图表的配置项和数据
				//app.title = '环形图';

				let option = {
						tooltip: {
							trigger: 'item',
							formatter: "{a} <br/>{b}: {c} ({d}%)"
						},
						legend: {
							orient: 'vertical',
							x: 'left',
							data: _this.data1
						},
						series: [{
								name: _this.name,
								type: 'pie',
								selectedMode: 'single',
								radius: [0, '30%'],

								label: {
									normal: {
										position: 'inner'
									}
								},
								labelLine: {
									normal: {
										show: false
									}
								}
							},
							{
								name: _this.name,
								type: 'pie',
								radius: ['30%', '40%'],
								label: {
									normal: {
										formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
										backgroundColor: '#eee',
										borderColor: '#aaa',
										borderWidth: 1,
										borderRadius: 4,
										// shadowBlur:3,
										// shadowOffsetX: 2,
										// shadowOffsetY: 2,
										// shadowColor: '#999',
										// padding: [0, 7],
										rich: {
											a: {
												color: '#999',
												lineHeight: 22,
												align: 'center'
											},
											// abg: {
											//     backgroundColor: '#333',
											//     width: '100%',
											//     align: 'right',
											//     height: 22,
											//     borderRadius: [4, 4, 0, 0]
											// },
											hr: {
												borderColor: '#aaa',
												width: '100%',
												borderWidth: 0.5,
												height: 0
											},
											b: {
												fontSize: 16,
												lineHeight: 33
											},
											per: {
												color: '#eee',
												backgroundColor: '#334455',
												padding: [2, 4],
												borderRadius: 2
											}
										}
									}
								},
								data: _this.data2
							}
						]
					};
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			}
		},
		
		beforeDestroy () {
		    myChart.clear()
		},
		mounted() {
			this.drawChart();
		}
	};
</script>
<style scoped="scoped">
	#bzt-main {
		border: 1px solid #092537;
		min-width: 500px;
		min-height: 400px;
		height: 400px;
	}
</style>



// WEBPACK FOOTER //
// src/components/comm/home/bingzhuangtu.vue